import { UserPermissions } from '@centecomm/portal-service';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import DirectoryNavigationIcon from '../../Icons/NavigationItem/Directory';

const LazyDirectoryPage = React.lazy(() => import('./Pages/DirectoryPage'));

const directoryConfiguration: FeatureConfiguration = {
    name: 'Directory',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureDirectoryTitle',
            url: '/directory',
            Icon: DirectoryNavigationIcon,
            ownerOperatorRoot: null,
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyDirectoryPage />
                </React.Suspense>
            ),
        },
        permissions: [UserPermissions.ViewDirectory],
    },
    disableFeature: [],
};

export default directoryConfiguration;
